export const DEBOUNCE_USER_INPUT = 200;

export const MOPLA_RIDES_TYPES_SEARCH_PARAM = 'ride_types';

export const MOPLA_RIDES_TYPES_SELECTED_CARD = 'selected_card';

export const SIGNUP_MINIMUM_AGE = 6;

export const SIGNUP_MAXIMUM_AGE = 105;
